// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"c0572f03","246":"325e8445","296":"215d2de3","369":"254ea9f5"}[chunkId] + ".chunk.css";
};